import { HardBreak } from '@tiptap/extension-hard-break';
import type { Node as ProseMirrorNode } from 'prosemirror-model';
import type { MarkdownNodeSpec } from 'tiptap-markdown';

const PlainTextHardBreak = HardBreak.extend({
  addStorage() {
    return {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      markdown: {
        serialize: (state, node: ProseMirrorNode, parent: ProseMirrorNode, index) => {
          // logic copied from tiptap-markdown but write only newline rather than using \ + newline
          for (let i = index + 1; i < parent.childCount; i++)
            if (parent.child(i).type === node.type) continue;

          const isInTable = 'inTable' in state && state.inTable;
          state.write(isInTable ? '<br>' : '\n');
          return;
        },
        parse: {},
      } as MarkdownNodeSpec,
    };
  },
});

export default PlainTextHardBreak;
